import { combineReducers } from "@reduxjs/toolkit";
import loginReducer from "../pages/Login/loginSlice";
import homeReducer from "../pages/Home/homeSlice";
import serviceReducer from "../services/serviceSlice";
import transportReducer from "../pages/Transports/slice";

const rootReducer = combineReducers({
  login: loginReducer,
  home: homeReducer,
  services: serviceReducer,
  transport: transportReducer,
});

export default rootReducer;
